import * as turf from '@turf/turf';

import {
  UserProjectSubscription,
  resetDraftState,
} from 'state/userAdminSlices';

import { parseDate } from 'features/common/datetimeUtils';
import { KM_TO_MILES } from 'features/common/utils';
import { Feature, FeatureCollection, Geometry } from 'geojson';

export function subscriptionHomeUrl(subscription_id: string): string {
  return `/manage/projects/${subscription_id}`;
}

export function newUPRUrl(subscription_id: string): string {
  return `/manage/projects/${subscription_id}/requests/new`;
}

export const PROJECT_TAB_PARAM = 'tab';
export const PROJECT_TAB_SPECIAL_EVENTS = 'special-events';

export function projectUrl(
  subscription_id: string,
  project: { hash_id?: string; project_id?: string },
) {
  let project_suffix;
  if (project.hash_id) {
    project_suffix = `requests/${project.hash_id}`;
  } else {
    project_suffix = project.project_id;
  }
  return `/manage/projects/${subscription_id}/${project_suffix}/`;
}

export function projectSpecialEventsUrl(
  subscription_id: string,
  project_id: string,
): string {
  return `${projectUrl(subscription_id, { project_id })}?${PROJECT_TAB_PARAM}=${PROJECT_TAB_SPECIAL_EVENTS}`;
}

export function navigateToNewRequest(
  subscription_id: string,
  navigate: Function,
  dispatch: Function,
) {
  dispatch(resetDraftState());
  navigate(newUPRUrl(subscription_id));
}

export const formatDateShort = (date: string) => {
  return new Intl.DateTimeFormat('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  }).format(parseDate(date).toDate());
};

export function formatDate(date: string) {
  if (!date) return undefined;
  return new Intl.DateTimeFormat('en-GB', {
    dateStyle: 'long',
  }).format(parseDate(date).toDate());
}

export function mi2Tokm2(mi2: number): number {
  return mi2 / KM_TO_MILES ** 2;
}

export function km2Tomi2(km2: number): number {
  return km2 * KM_TO_MILES ** 2;
}

export function formatArea(km2s: number, uses_metric: boolean) {
  if (uses_metric) {
    return `${km2s.toLocaleString(undefined, { maximumSignificantDigits: 3 })}km²`;
  } else {
    return `${km2Tomi2(km2s).toLocaleString(undefined, { maximumSignificantDigits: 3 })}mi²`;
  }
}

export function formatAreaMi2(mi2s: number, uses_metric: boolean) {
  if (!uses_metric) {
    return `${mi2s.toLocaleString(undefined, { maximumSignificantDigits: 3 })}mi²`;
  } else {
    return `${mi2Tokm2(mi2s).toLocaleString(undefined, { maximumSignificantDigits: 3 })}km²`;
  }
}

export function subscriptionUsesMetric(subscription: UserProjectSubscription) {
  if (subscription?.template) {
    return subscription.template.uses_metric;
  } else if (subscription.projects.length > 0) {
    return subscription.projects[0].uses_metric;
  }
  return false;
}

export function formattedAreaFromBoundary(
  boundary: Feature<any> | FeatureCollection<any> | Geometry,
  subscription: UserProjectSubscription,
) {
  const area_km2 = turf.area(boundary) / 1000000;
  return formatArea(area_km2, subscriptionUsesMetric(subscription));
}
